import { BookOpen } from "lucide-react";
import { toast } from "sonner";
import { FolderSection } from "@/components/FolderSection";
import { ScanAudiobooksButton, useAudiobookScan } from "@/components/ScanAudiobooks";

/* FileJump folders whose albums are treated as audiobooks; "Scan audiobook folders" imports only these. */
export const AudiobookFolders = ({ creds }) => {
  const scan = useAudiobookScan();
  return (
    <FolderSection id="audiobooks" testid="audiobook-folders" creds={creds} endpoint="/audiobooks/folders"
      icon={<BookOpen size={14} />} title="Audiobook folders"
      description="Everything inside these folders shows up under Audiobooks instead of Albums. “Scan audiobook folders” reads only these folders — folders beside your music root work too."
      scanButton={<ScanAudiobooksButton scan={scan} testid="audiobook-folders-scan" className="!h-8" />}
      onSaved={(data, picked) => {
        toast.success(`Audiobook folders saved — ${data.books} book${data.books === 1 ? "" : "s"} found`);
        if (data.outside_root?.length && picked.length) toast.message("This folder is outside your music root", { description: "Press “Scan audiobook folders” to import its files." });
      }} />
  );
};
